import React, { useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import MainLayout from "../../components/layout/MainLayout";
import CancerEvaluationHeader from "../../components/layout/Header/CancerEvaluationHeader";
import CancerMainFooter from "../../components/layout/Footer/CancerMainFooter";
import FormList from "./FormList";
import { ADD_SERVEY } from "../../services/actions/_actionType";
import { addServey } from "../../services/actions/_actions";
import axios from "axios";
import Modal from "@material-ui/core/Modal";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

const datas = JSON.stringify([
  {
    no: 1,
    text: "해당 영상에 대해 전반적으로 만족하십니까?",
    list: [
      "전혀 그렇지 않다",
      "조금 아쉽다",
      "보통이다",
      "만족한다",
      "매우 만족한다",
    ],
  },
  {
    no: 2,
    text: "영상의 길이는 적당하였습니까?",
    list: ["매우 짧다", "조금 짧다", "적당하다", "조금 길다", "매우 길다"],
  },
  {
    no: 3,
    text: "영상에 포함된 정보의 양은 적당하였습니까?",
    list: [
      "매우 부족하다",
      "조금 부족하다",
      "적당하다",
      "조금 많다",
      "매우 많다",
    ],
  },
  {
    no: 4,
    text: "영상에 포함 된 정보의 방향성은 어떠셨습니까?",
    list: [
      "[cancer] 검진을 권장하는 것 같다.",
      "[cancer] 검진을 스스로 결정하게 한다.",
      "[cancer] 검진을 권장하지 않는 것 같다.",
    ],
  },
  {
    no: 5,
    text:
      "영상을 시청한 이후, 추후 검진을 결정하는 데에 도움이 되었다고 생각하십니까?",
    list: [
      "전혀 도움 안된다",
      "별로 도움 안된다",
      "조금 도움된다",
      "충분히 도움된다",
      "잘 모르겠다",
    ],
  },
  {
    no: 6,
    text:
      "영상을 시청한 이후, 스스로 검진에 대한 결정을 자신있게 내리실 수 있게 되었습니까?",
    list: [
      "전혀 그렇지 않다",
      "그렇지 않다",
      "조금 그렇다",
      "매우 그렇다",
      "잘 모르겠다",
    ],
  },
]);

const replaceAll = (str, searchStr, replaceStr) =>
{
    return str.split(searchStr).join(replaceStr);
};

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    backgroundColor: theme.palette.background.paper,
    padding: 24,
  },
  modalText: {
    paddingTop: 12,
    paddingBottom: 12,
    lineHeight: 1.65,
  },
}));

const EvaluationComp = ({
  cancer = "lung",
  prosData,
  lungData,
  breastData,
  thyroidData,
  loading,
  survey,
  success,
  error,
  message,
  addServeyApi,
}) => {
  let cancerName = cancer === "thyroid" ? "갑상선암" : cancer === "breast" ? "유방암" : cancer === "lung" ? "폐암" : "전립선암";
  const dataThis = JSON.parse(replaceAll(datas, "[cancer]", cancerName));
  const [que, serQue] = useState([3, 2, 2, 1, 2, 2]);
  const [isOpen, setIsOpen] = useState(false);
  const classes = useStyles();
  const handleComplete = async (cancer) => {
    const check = cancer === "thyroid" ? thyroidData.complete : cancer === "breast" ? breastData.complete : cancer === "lung" ? lungData.complete : prosData.complete;
    const checkText = cancer === "thyroid" ? "갑상선암" : cancer === "breast" ? "유방암" : cancer === "lung" ? "폐암" : "전립선암";
    if (!check) {
      alert(
        `'나의 ${checkText} 발생 위험도 계산하기' 를 작성후 이용 가능합니다.`
      );
      return false;
    }
    let cancerData = cancer === "thyroid" ? thyroidData.thyroidData : cancer === "breast" ? breastData.breastData :
      cancer === "lung" ? lungData.lungData : prosData.prostateData;
    const res = await axios.get("https://geolocation-db.com/json/");
    setIsOpen(true);
    if (cancer === "thyroid") {
      addServeyApi({
        // cancerName: cancerName,
        // ip: res.data.IPv4,
        // id: "12341",
        // que: que,
        // age: cancerData.age,
        // sex: cancerData.sex,
        // cm: cancerData.cm,
        // kg: cancerData.kg,
        // dmyn: cancerData.dmyn,
        // hbp: cancerData.hbp,
        // smoking: cancerData.brsmoking,
        // drinking: cancerData.drinking,
        // total: breastData.total,
      });
    } else if (cancer === "breast") {
      addServeyApi({
        cancerName: cancerName,
        ip: res.data.IPv4,
        id: "12341",
        que: que,
        age: cancerData.age,
        sex: cancerData.sex,
        cm: cancerData.cm,
        kg: cancerData.kg,
        dmyn: cancerData.dmyn,
        hbp: cancerData.hbp,
        smoking: cancerData.brsmoking,
        drinking: cancerData.drinking,
        total: breastData.total,
      });
    } else if (cancer === "lung") {
      addServeyApi({
        cancerName: cancerName,
        ip: res.data.IPv4,
        id: "12341",
        que: que,
        age: cancerData.age,
        sex: cancerData.sex,
        cm: cancerData.cm,
        kg: cancerData.kg,
        dmyn: cancerData.dmyn,
        pye: cancerData.pye,
        tbsick: cancerData.tbsick,
        hpyn: null,
        pa: null,
        smoking: cancerData.smoking,
        gapYear: cancerData.gapYear,
        smokingGap: cancerData.smokingGap,
        total: lungData.total,
      });
    } else {
      addServeyApi({
        cancerName: cancerName,
        ip: res.data.IPv4,
        id: "12341",
        que: que,
        age: cancerData.age,
        sex: cancerData.sex,
        cm: cancerData.cm,
        kg: cancerData.kg,
        dmyn: cancerData.dmyn,
        pye: null,
        tbsick: null,
        hpyn: cancerData.hpyn,
        pa: cancerData.pa,
        smoking: cancerData.smoking,
        gapYear: cancerData.gapYear,
        smokingGap: cancerData.smokingGap,
        total: prosData.total,
      });
    }
  };

  const handleClose = () => {
    window.location.href = "/";
  };

  const handleChange = useCallback(
    (no, index) => {
      const newArray = que.map((q, i) => {
        if (i === no) {
          return index;
        } else {
          return q;
        }
      });
      serQue(newArray);
    },
    [que]
  );
  return (
    <>
      <MainLayout
        header={<CancerEvaluationHeader cancer={cancerName} sub={true} />}
        footer={
          <CancerMainFooter
            name1="완료"
            onClick1={() => handleComplete(cancer)}
          />
        }
      >
        <FormList datas={dataThis} que={que} cancer={cancerName} handleChange={handleChange} />
      </MainLayout>
      <Modal
        open={isOpen}
        onClose={() => handleClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.modal}>
          {loading ? (
            <></>
          ) : (
            <>
              <Typography
                id="modal-modal-title"
                variant="h5"
                align="center"
                className={classes.modalText}
              >
                {success ? (
                  <>
                    사용 후 평가 설문을 완료 하였습니다
                    <br />
                    설문 작성을 해주셔서 감사합니다.
                    <br />
                  </>
                ) : (
                  <>
                    사용 후 평가 설문을 실패하였습니다.
                    <br />
                    {message}
                    <br />
                  </>
                )}
              </Typography>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={{ marginTop: 24 }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  fullWidth
                  onClick={() => handleClose()}
                >
                  확인
                </Button>
              </Grid>
            </>
          )}
        </Box>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    survey: state.survey,
    success: state.survey.success,
    error: state.survey.error,
    message: state.survey.message,
    loading: state.loading[ADD_SERVEY],
    lungData: state.lungRe,
    prosData: state.prostateRe,
    breastData: state.breastRe,
    thyroidData: state.thyroidRe,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addServeyApi: (datas) => {
      dispatch(addServey({ datas }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EvaluationComp);
